"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var Nav_base_1 = require("./Nav.base");
var Nav_styles_1 = require("./Nav.styles");
exports.Nav = Utilities_1.styled(Nav_base_1.NavBase, Nav_styles_1.getStyles);
//# sourceMappingURL=Nav.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/Nav/Nav.js
// module id = 1026
// module chunks = 0